module.exports = __webpack_public_path__ + "04_short_gray.55691151.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_short_gray.png
// module id = ckPT
// module chunks = 0